import {DomainStore} from 'shared/store';
import { makeAutoObservable } from 'mobx';
import {t} from 'shared/core';
import {endpoints, types, urls} from 'main/tools';
import {successAlert, redirect} from 'shared/tools';
import {Company} from 'main/stores/company';

class OfferDirectoryState {
  interactiveAgent;
  store = new DomainStore();
  history;

  company;
  selectedOffer;
  revokeOfferModalOpen = false;
  revokeReasonModalOpen = false;
  offerPreviewModalOpen = false;

  constructor() {
    makeAutoObservable(this, {
      interactiveAgent: false,
      store: false,
      history: false
    });
  }

  setInteractiveAgent(agent) {
    this.interactiveAgent = agent;
  }

  receiveProps({history}) {
    this.history = history;
  }

  async load() {
    const compose = [
      endpoints.CURRENT_COMPANY
    ];
    await this.store._compose(compose);

    this.company = new Company(this.store._getSingle(types.COMPANY));
  }

  goToNewOfferPage() {
    this.history.push('new');
  }

  async hire(offer) {
    const {model} = await this.store.post(offer.link('hire'), types.EMPLOYEE_DETAILS);
    return redirect(urls.EMPLOYEE.with(model.id));
  }

  openRevokeOfferModal(offer) {
    this.selectedOffer = offer;
    this.revokeOfferModalOpen = true;
  }

  closeRevokeOfferModal() {
    this.revokeOfferModalOpen = false;
    this.selectedOffer = null;
  }

  openRevokeReasonModal(offer) {
    this.selectedOffer = offer;
    this.revokeReasonModalOpen = true;
  }

  closeRevokeReasonModal() {
    this.revokeReasonModalOpen = false;
    this.selectedOffer = null;
  }

  openOfferPreviewModal(offer) {
    this.selectedOffer = offer;
    this.offerPreviewModalOpen = true;
  }

  closeOfferPreviewModal() {
    this.offerPreviewModalOpen = false;
    this.selectedOffer = null;
  }

  async revokeOffer() {
    const {model} = await this.store.patch(
      endpoints.OFFER.REVOKE.with(this.selectedOffer.id),
      types.OFFER,
      this.selectedOffer
    );

    if (model) {
      this.interactiveAgent.refresh();
      successAlert(t('offers.directory.revoke_offer.Offer revoked.'));
      this.closeRevokeOfferModal();
    }
  }

  async removeOffer(offer) {
    await this.store.destroy(offer);
  }

  customLinksFor(offer) {
    const links = [];
    if (offer.hasLink('hire')) {
      links.push({
        order: 1,
        text: 'offers.directory.hire.Hire',
        action: model => this.hire(model)
      });
    }
    if (offer.hasLink('revoke')) {
      links.push({
        order: 1,
        text: 'offers.directory.revoke_offer.Revoke',
        action: model => this.openRevokeOfferModal(model)
      });
    }
    links.push({
      order: 1,
      text: 'offers.directory.Preview offer',
      action: model => this.openOfferPreviewModal(model)
    });
    if (offer.offerDocument) {
      links.push({
        order: 1,
        text: 'offers.directory.Download offer letter',
        downloadLink: offer.offerDocument.link('url')
      });
    }


    return links;
  }
}

export default OfferDirectoryState;
